import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getInternalCompaniesAsync, createOrUpdateInternalCompanyAsync } from './internalCompanyThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const internalCompanySlice = createSlice({
    name: 'internalCompany',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInternalCompaniesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInternalCompaniesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.internalCompanies = action.payload;
        })
            .addCase(getInternalCompaniesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createOrUpdateInternalCompanyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createOrUpdateInternalCompanyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            const payload = action.payload;
            if (!state.internalCompanies) {
                state.internalCompanies = [payload];
            }
            else {
                const index = state.internalCompanies.findIndex((x) => x.id === payload.id);
                if (index >= 0) {
                    state.internalCompanies = state.internalCompanies.map((x, i) => (i === index ? payload : x));
                }
                else {
                    state.internalCompanies = [...state.internalCompanies, payload];
                }
            }
        })
            .addCase(createOrUpdateInternalCompanyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default internalCompanySlice.reducer;
